(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["momofuku-home-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    class MomofukuHomeHero {
      constructor(section) {
        this.section = section;
        this.slides = [...section.querySelectorAll('.momofuku-home-hero__slide')];
        this.dots = [...section.querySelectorAll('.momofuku-home-hero__dot')];
        this.index = 0;
        this.delay = Number(section.dataset.autoplaySeconds || 0) * 1000;
        this.timer = null;
        this.bind();
        this.start();
      }

      bind() {
        this.section.querySelectorAll('[data-slide-target]').forEach((button) => {
          button.addEventListener('click', () => this.goTo(Number(button.dataset.slideTarget)));
        });

        this.section.querySelectorAll('[data-direction]').forEach((button) => {
          button.addEventListener('click', () => {
            const direction = button.dataset.direction === 'prev' ? -1 : 1;
            this.goTo((this.index + direction + this.slides.length) % this.slides.length);
          });
        });

        this.section.addEventListener('mouseenter', () => this.stop());
        this.section.addEventListener('mouseleave', () => this.start());
      }

      goTo(index) {
        this.index = index;
        this.slides.forEach((slide, slideIndex) => {
          slide.classList.toggle('is-active', slideIndex === index);
        });
        this.dots.forEach((dot, dotIndex) => {
          dot.classList.toggle('is-active', dotIndex === index);
        });
        this.start();
      }

      start() {
        this.stop();
        if (this.delay < 1000 || this.slides.length < 2) return;
        this.timer = window.setTimeout(() => {
          this.goTo((this.index + 1) % this.slides.length);
        }, this.delay);
      }

      stop() {
        if (this.timer) {
          window.clearTimeout(this.timer);
          this.timer = null;
        }
      }
    }

    document.querySelectorAll('.momofuku-home-hero').forEach((section) => {
      if (!section.dataset.momofukuHeroReady) {
        section.dataset.momofukuHeroReady = 'true';
        new MomofukuHomeHero(section);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["momofuku-testimonials"] && !Shopify.designMode) return;
  try {
    
  (() => {
    for (const section of document.querySelectorAll('.momofuku-testimonials')) {
      if (section.dataset.testimonialsReady === 'true') continue;
      const rail = section.querySelector('.momofuku-testimonials__rail');
      if (!rail) continue;
      section.dataset.testimonialsReady = 'true';
      for (const button of section.querySelectorAll('[data-testimonials-direction]')) {
        button.addEventListener('click', () => {
          const card = rail.querySelector('.momofuku-testimonials__card');
          const distance = card ? card.getBoundingClientRect().width + 20 : rail.clientWidth * 0.8;
          rail.scrollBy({ left: button.dataset.testimonialsDirection === 'prev' ? -distance : distance, behavior: 'smooth' });
        });
      }
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
